import { ref } from 'vue';
export const useIgnoreRule = () => {
    const ignoreRuleIds = ref([]);
    const ignoreAutoFixIds = ref([]);
    const addIgnoreRuleId = (uniqueId) => {
        ignoreRuleIds.value.push(uniqueId);
        ignoreAutoFixIds.value.push(uniqueId);
    };
    const hideLintResult = (uniqueId) => {
        document.querySelectorAll(`.js-result-element[data-unique_id="${uniqueId}"]`).forEach((element) => {
            element.style.display = 'none';
        });
    };
    const removePointOutSpan = (uniqueId) => {
        let spanElements = document.querySelectorAll(`.js-point-out-span[data-rule_unique_id="${uniqueId}"]`);
        spanElements.forEach((element) => {
            element.outerHTML = element.textContent;
        });
    };
    const resetIgnoreRuleIds = () => {
        ignoreRuleIds.value = [];
    };
    return {
        ignoreRuleIds,
        ignoreAutoFixIds,
        addIgnoreRuleId,
        hideLintResult,
        removePointOutSpan,
        resetIgnoreRuleIds
    };
};
